/**
 * Switch Component
 *
 * Minimal wrapper around Radix Switch.
 */

import * as SwitchPrimitive from '@radix-ui/react-switch';
import React from 'react';

import { cn } from '@/lib/utils';

export interface SwitchProps extends React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root> {}

export const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  SwitchProps
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    className={cn(
      'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border border-border',
      'transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
      'data-[state=checked]:bg-primary data-[state=unchecked]:bg-muted',
      className
    )}
    {...props}
  >
    <SwitchPrimitive.Thumb
      className={cn(
        'pointer-events-none block h-4 w-4 rounded-full bg-background shadow',
        'transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-1'
      )}
    />
  </SwitchPrimitive.Root>
));
Switch.displayName = 'Switch';
